import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { helpers } from '@bingads-webui/projection-grid-base-column';

import { generateHelpId, hasFluctuations, formatMetricValue } from '../utils';
import performanceMetricWithFluctuationTemplate from './performance-metric-with-fluctuation.pug';
import { ColumnNameToFluctuationTypeEnum } from './fluctuation-type-enum';

const Scope = 'PerformanceMetrics';
export class FluctuationBaseColumn extends CampaignuiBaseColumn {
  /**
   * Returns sortable property for the column config.
   * @param {Object} config column config
   * @returns {string} sortable property
   */
  static columnSortableProperty = config => `${Scope}/${config.name}`;

  constructor(config) {
    const { name, i18n } = config;
    const helpId = generateHelpId(config);

    // This configuration for property is not taking effect now.
    // We should update getColumnsMap() in
    // ui-legacy\Assets\campaignui\feature\campaigns-tab\campaigns\grid\columns-config-base.es
    // to make to column to property mapping correctly in odata request.
    const property = [`${Scope}/${name}`, 'AvailableInsightTypeIds'];
    const title = config.i18n.getString(`ColumnName_${name}`);

    super(_.defaults(
      { helpId, property, title },
      config,
      {
        type: 'number',
        sortable: FluctuationBaseColumn.columnSortableProperty(config),
        helpAriaLabel: helpId && i18n
          ? i18n.getString('Click to learn more about {{item}}', { item: name })
          : '',
      }
    ));
  }

  pickProperty(item) {
    const { PerformanceMetrics, AvailableInsightTypeIds, GoalStatusDetails } = item;
    const {
      name, format, i18n, title,
    } = this.config;
    const metricValue = _.result(PerformanceMetrics, name);

    // goal details is array
    // if goal delivery status is 'NoEligibleGoal', 'TagUnverified' or 'TagInactive' we show the warning
    const hasGoalLimits = GoalStatusDetails && _.find(GoalStatusDetails, goal => _.contains(['NoEligibleGoal', 'TagUnverified', 'TagInactive', 'NoRecentOfflineConversion'], goal.GoalDeliveryStatus));

    const propertys = {
      metricType: ColumnNameToFluctuationTypeEnum[name],
      metricName: title,
      metricValue: formatMetricValue({ i18n, format, metricValue }),
      hasFluctuation: hasFluctuations({
        propertyName: name,
        availableInsightTypeIds: AvailableInsightTypeIds,
        IsOverall: item.$total && item.$total.type === 'overall',
      }),
      hasConversionDeliveryStatus: hasGoalLimits && name === 'ConversionsCredit',
    };
    return propertys;
  }

  get template() { return performanceMetricWithFluctuationTemplate; }

  get title() {
    return this.config.title;
  }

  get colClasses() {
    let colClasses = super.colClasses;
    colClasses = helpers.mergeClasses(colClasses, [
      'performance-metrics',
      `performance-metrics-${this.name}`,
    ]);

    return colClasses;
  }
}

